<template>
  <div>
    <div class="d-flex align-center">
      <v-text-field
        label="Recherchez votre organisation"
        append-icon="mdi-magnify"
        v-model="keyword"
        outlined
        :disabled="updating"
        :loading="updating"
        @click:append="search"
        @keydown.enter="search"
        style="max-width: 400px"
        autocomplete="nope"
      ></v-text-field>
    </div>
    <v-alert text border="left" type="info" v-show="this.errorMessage">{{ this.errorMessage }}</v-alert>

    <v-dialog v-model="dialog" width="700">
      <v-card class="pa-6">
        <h2 class="headline mb-3">Résultats</h2>
        <p>Sélectionnez votre organisation dans la liste. Si elle n'est pas répertoriée, continuez le formulaire.</p>
        <v-card
          v-for="organisation in result"
          :key="organisation.id"
          @click="organisationSelected(organisation)"
          class="pa-6 mb-3"
          outlined
          max-width="450"
        >
          <h3>{{ organisation.nomEmployeur }}</h3>
          <p class="mb-0 caption">{{ organisation.adresse }} {{ organisation.complementAdresse }}</p>
          <p class="mb-0 caption">{{ organisation.ville }}, {{ textProvince(organisation.province) }} {{ organisation.codePostal }}</p>
          <p class="mb-0 caption">{{ textPays(organisation.pays) }}</p>
        </v-card>
        <div class="text-center mt-6">
          <v-btn color="primary" @click="dialog = false">Mon organisation n'est pas répertoriée</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { Api } from "@/plugins/api"
import CataloguesHelper from "@/mixins/CataloguesHelpers"
export default {
  mixins: [CataloguesHelper],
  data() {
    return {
      keyword: "",
      updating: false,
      result: [],
      errorMessage: "",
      dialog: false
    }
  },
  methods: {
    search() {
      this.result = []
      this.updating = true
      Api.get("/organisations/search?keyword=" + this.keyword)
        .then((res) => {
          this.result = res.data
          if (this.result.length == 0) {
            this.errorMessage = "Aucune organisation trouvée, essayez un autre mot-clé."
          } else {
            this.dialog = true
            this.errorMessage = ""
          }
        })
        .catch((err) => {
          this.result = []
          this.errorMessage = err.response.data.message
        })
        .finally(() => {
          this.updating = false
        })
    },
    organisationSelected(organisation) {
      this.$emit("organisation-selected", { ...organisation })
      this.keyword = organisation.nomEmployeur
      this.dialog = false
    }
  }
}
</script>

<style>
</style>